import React from 'react';

import IconButton from '@components/IconButton';
import Icon from '@components/Icon';
import useLocalStorage from '@hooks/useLocalStorage';

interface InformationBannerProps {}

const InformationBanner = ({}: InformationBannerProps) => {
  const [showBanner, setShowBanner] = useLocalStorage(
    'show-information-banner',
    'false'
  );

  const handleCloseButtonClick = () => setShowBanner('false');

  return (
    <>
      {showBanner === 'true' && (
        <div className="bg-white px-6 py-2 text-dark text-body font-semibold relative text-center">
          <p>
            Cronos Mainnet will be upgrading their network at block height
            6542800, approximately 18th Jan 2023, 0300 (GMT) for 60 minutes.
          </p>

          <IconButton
            className="text-iconMedium absolute right-0 top-0 -m-1 mr-2 mt-1"
            onClick={handleCloseButtonClick}
          >
            <Icon.Close />
          </IconButton>
        </div>
      )}
    </>
  );
};

export default InformationBanner;
